<template>
  <line-chart :chart-data="chartData" :options="options" />
</template>

<script>
import LineChart from "@/components/charts/types/LineChart.vue";

export default {
  name: "ActivityLineChart",
  components: {
    LineChart,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              color: "rgb(156, 163, 175)",
              font: {
                size: 12,
              },
            },
          },
          title: {
            display: false,
            text: "Aggregated stats",
            color: "rgb(156, 163, 175)",
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 5,
              color: "rgb(156, 163, 175)",
              font: {
                size: 11,
              },
            },
            grid: {
              color: "rgba(75, 85, 99, 0.2)",
            },
          },
          x: {
            display: true,
            grid: {
              display: false,
            },
            ticks: {
              color: "rgb(156, 163, 175)",
              font: {
                size: 11,
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}
</style>
